/**
 * MSSQL built-in JSON function signatures — one family slice of the static
 * catalog composed by `mssqlBuiltinRoutines.ts` (see that file's header for
 * why this exists and the precedence rule vs. user routines).
 */

import type { RoutineMetadata, RoutineParameter } from '../../../../types/electron';

type Entry = RoutineMetadata & { documentation?: string };

function p(name: string, dataType: string): RoutineParameter {
  return { name, dataType };
}

function opt(name: string, dataType: string): RoutineParameter {
  return { name: `[${name}]`, dataType };
}

function entry(name: string, parameters: RoutineParameter[], documentation?: string): Entry {
  return { schema: '', name, parameters, ...(documentation ? { documentation } : {}) };
}

export const MSSQL_JSON_ROUTINES: ReadonlyMap<string, Entry> = new Map([
  ['isjson', entry('ISJSON', [p('expression', 'nvarchar'), opt('json_type_constraint', 'varchar')], 'Return 1 if a string is valid JSON (optionally of a required type, 2022+).')],
  ['json_array', entry('JSON_ARRAY', [opt('value, ...', 'any')], 'Construct a JSON array from a list of values (empty array if omitted).')],
  ['json_modify', entry('JSON_MODIFY', [p('expression', 'nvarchar'), p('path', 'varchar'), p('newValue', 'any')], 'Update the value at a JSON path and return the updated JSON string.')],
  ['json_object', entry('JSON_OBJECT', [opt('key:value, ...', 'any')], 'Construct a JSON object from key:value pairs (empty object if omitted).')],
  ['json_path_exists', entry('JSON_PATH_EXISTS', [p('expression', 'nvarchar'), p('path', 'varchar')], 'Return 1 if the JSON path exists in the input, else 0.')],
  ['json_query', entry('JSON_QUERY', [p('expression', 'nvarchar'), opt('path', 'varchar')], 'Extract an object or array from a JSON string at the given path.')],
  ['json_value', entry('JSON_VALUE', [p('expression', 'nvarchar'), p('path', 'varchar')], 'Extract a scalar value from a JSON string at the given path.')],
  ['openjson', entry('OPENJSON', [p('expression', 'nvarchar'), opt('path', 'varchar')], 'Parse JSON text into rows/columns (table-valued function; WITH clause not shown).')],
]);
